import { setTokenAction } from '@tshio/redux-api-auth-middleware';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { login } from 'store/api/authorization/authorizationActions';
import { submitForm } from 'store/api/submitForm/submitForm';
import { LoginResponse } from 'store/api/types';
import { AUTH_COOKIE, AUTH_REFRESH_COOKIE } from 'store/store';
import { setSecureCookie } from 'utils';

import { Login } from './Login';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onLogin: submitForm<LoginResponse>(dispatch, login),
  onSetToken: (accessToken: string, refreshToken: string, expiresIn: number) => {
    setSecureCookie(AUTH_COOKIE, accessToken);
    setSecureCookie(AUTH_REFRESH_COOKIE, refreshToken);
    dispatch(setTokenAction({ access_token: accessToken, refresh_token: refreshToken, expires_in: expiresIn }));
  },
});

export const LoginContainer = withRouter(
  compose(
    connect(
      undefined,
      mapDispatchToProps,
    ),
  )(Login),
);
